module.exports = __webpack_public_path__ + "img/flight_icon.698dcb95.svg";